var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-container page"
  }, [_vm.isError ? _c('div', [_c('MemberButton', {
    attrs: {
      "button-text": "回官方帳號",
      "type": "OA"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }